import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RichsnipetService } from 'dmmp-services'

@Component({
  selector: 'dmmp-reactive-search',
  templateUrl: './reactive-search.component.html',
})
export class ReactiveSearchComponent {

  schema: object
  @Input() module: any
  @Input() result: any
  @Input() identifier: string
  @Input() inSlide: boolean
  @Input() paginationState: any
  @Input() searchName: string
  @Output() clearResult = new EventEmitter()
  @Output() close = new EventEmitter()
  @Output() search = new EventEmitter()
  @Output() page = new EventEmitter()
  @Input() currentFilters: any
  @Input() currentSearchUpdate: any
  @Input() contentResult: any
  @Input() loaderState: boolean
  @Input() isGeneralSearch: boolean
  @Output() currentSearch = new EventEmitter()
  @Input() relateUrl: string

  constructor(private richsnipetService: RichsnipetService) {
    this.buildSchema('')
  }

  buildSchema(userSearch) {
    this.schema = this.richsnipetService.setupJsonSearchUniversity(userSearch)
    this.currentSearch.emit(userSearch)
  }
}
